export default __webpack_public_path__ + "static/SmileSushiLogo-442a25150a5bbbb534a0cfc5f61fea0b.png";